/* =============== SALTY PRIDE — CUSTOM JS =================
   [A] Announcement bar: hide when user starts scrolling DOWN
       - One-time per page view (no persistence)
       - Smooth height animation (no display:none), no jump
   [B] Header transparency: subtle glass on scroll
   ======================================================== */

(function () {
  /* ------------------ [A] Announcement Bar ------------------ */
  function initAnnouncement() {
    var bar = document.querySelector('.announcement-bar-section');
    if (!bar) return;

    var collapsed = false;
    var lastY = window.scrollY;

    function collapseSmoothly() {
      if (collapsed) return;
      collapsed = true;

      // Measure current height and animate to 0 (layout moves smoothly)
      var startH = bar.getBoundingClientRect().height || bar.offsetHeight || 0;
      if (startH <= 0) return; // nothing to do

      // Prepare for height animation (keep element in flow; no display:none)
      bar.style.overflow = 'hidden';
      bar.style.height = startH + 'px';
      bar.style.transition = 'height 240ms ease';

      // Force reflow so browser registers the starting height
      // eslint-disable-next-line no-unused-expressions
      bar.offsetHeight;

      // Animate to 0
      bar.style.height = '0px';
      bar.classList.add('sp-announce-zero'); // keep height:0 on fast navs

      // Clean up once done (keep height 0; element remains visually gone)
      bar.addEventListener('transitionend', function onEnd(e) {
        if (e.propertyName !== 'height') return;
        bar.removeEventListener('transitionend', onEnd);
        bar.style.height = '0px';
        bar.style.overflow = 'hidden';
        // Do NOT set display:none; that causes snaps on some devices.
      }, { once: true });
    }

    // Hide as soon as the user starts scrolling DOWN a bit from the top.
    function onScroll() {
      var y = window.scrollY || 0;
      var down = y > lastY + 6;          // tiny hysteresis to ignore micro scrolls
      if (!collapsed && down && y > 0) { // only act when actually moving down
        collapseSmoothly();
        window.removeEventListener('scroll', onScroll, { passive: true });
      }
      lastY = y;
    }

    // Seed lastY and start listening
    lastY = window.scrollY || 0;
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ------------------ [B] Header Transparency ------------------ */
  function initHeaderGlass() {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;

    header.classList.add('sp-header-init');

    var lastState = null;
    var THRESHOLD = 50; // px scrolled before translucency

    function applyState(scrolled) {
      if (scrolled === lastState) return;
      lastState = scrolled;
      header.classList.toggle('sp-header-translucent', scrolled);
    }

    applyState(window.scrollY > THRESHOLD);
    window.addEventListener('scroll', function () {
      applyState(window.scrollY > THRESHOLD);
    }, { passive: true });
  }

  /* ------------------ Boot everything ------------------ */
  function boot() {
    initAnnouncement();
    initHeaderGlass();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
